import styles from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockSlide/ProductGalleryBlockSlide.styles';
import { IParsedImage } from '@components/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  image: IParsedImage;
};
const ProductGalleryBlockSlide = ({
  image
}: PropsType) => {
  if (!image.image.desktop) return <></>;
  return <div sx={styles.imageSlide}>
      <ResponsiveImage image={image.image} blur={image.blur} alt="" sx={styles.imageSlide.img} />
    </div>;
};
export default ProductGalleryBlockSlide;